import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanReturn 
{
  canReturn: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})

export class CanReturnGuard implements CanDeactivate<CanReturn> 
{
  canDeactivate(component: CanReturn) 
  {
    return component.canReturn ? component.canReturn() : true;
  }
}